import {
  TActivePool,
  TAggregatorV3Interface,
  TBalLiquidityGaugeV5,
  TBalancerVault,
  TBorrowerOperations,
  TCommunityIssuance,
  TCurveFactoryPool,
  TERC20,
  TFeeTracker,
  TFraxStaking,
  TGLPManager,
  THintHelpers,
  TPriceFeed,
  TSavingModuleStabilityPool,
  TSortedTroves,
  TStabilityPool,
  TStabilityPoolManager,
  TVSTOracle,
  TVaultManager,
  TVestaDexTrader,
  TVestaEIR,
  TVestaFarming,
  TVestaGMXBonusStaking,
  TVestaInterestManager,
  TVestaNFT,
  TVestaParameters,
  TVestaSavingModule,
  TVestaVaultStaking,
  TVestingVesta,
} from '~components/providers/types';
import { EContractName } from '~config/protocol/contractConfig';
import {
  AllVestaAssets,
  BalFarm,
  ChainlinkAssets,
  ELPType,
  EVestaAsset,
  FraxFarm,
  VestaFarm,
} from '~config/types';

import { useProtocolContract } from '../useProtocolContract';

export const useContractPriceFeed = () => useProtocolContract<TPriceFeed>(EContractName.PriceFeed);

export const useContractCommunityIssuance = () =>
  useProtocolContract<TCommunityIssuance>(EContractName.CommunityIssuance);

export const useContractStabilityPoolManager = () =>
  useProtocolContract<TStabilityPoolManager>(EContractName.StabilityPoolManager);

export const useContractVaultManager = () => useProtocolContract<TVaultManager>(EContractName.VaultManager);

export const useContractVestaParameters = () =>
  useProtocolContract<TVestaParameters>(EContractName.VestaParameters);

export const useContractBorrowerOperations = () =>
  useProtocolContract<TBorrowerOperations>(EContractName.BorrowerOperations);

export const useContractVestaVesting = () => useProtocolContract<TVestingVesta>(EContractName.VestingVesta);

export const useContractHintHelpers = () => useProtocolContract<THintHelpers>(EContractName.HintHelpers);

export const useContractSortedVaults = () => useProtocolContract<TSortedTroves>(EContractName.SortedTroves);

export const useContractBalPool = () => useProtocolContract<TBalancerVault>(EContractName.BalancerVault);

export const useContractVestaNFT = () => useProtocolContract<TVestaNFT>(EContractName.VestaNFT);

export const useContractVSTOracle = () => useProtocolContract<TVSTOracle>(EContractName.VSTOracle);

export const useContractStabilityPool = (asset: EVestaAsset) =>
  useProtocolContract<TStabilityPool, EVestaAsset>('StabilityPool', asset);

export const useContractAsset = (asset: AllVestaAssets) => useProtocolContract<TERC20>('Asset', asset);

export const useContractVestaFarm = (farm: VestaFarm) =>
  useProtocolContract<TVestaFarming, VestaFarm>('VestaFarm', farm);

export const useContractBalGauge = (farm: BalFarm) =>
  useProtocolContract<TBalLiquidityGaugeV5, BalFarm>('BalGauge', farm);

export const useContractFraxFarm = (farm: FraxFarm) =>
  useProtocolContract<TFraxStaking, FraxFarm>('FraxFarm', farm);

export const useContractCurveFactoryPool = (lp: ELPType) =>
  useProtocolContract<TCurveFactoryPool, ELPType>('CurveFactoryPool', lp);

export const useContractVaultRewards = (asset: EVestaAsset) =>
  useProtocolContract<TVestaVaultStaking, EVestaAsset>('VaultRewards', asset);

export const useContractFeeTracker = (asset: EVestaAsset) =>
  useProtocolContract<TFeeTracker, EVestaAsset>('FeeTracker', asset);

export const useContractGLPManager = () => useProtocolContract<TGLPManager>(EContractName.GLPManager);

export const useContractActivePool = () => useProtocolContract<TActivePool>(EContractName.ActivePool);

export const useContractChainlinkOracles = (asset: ChainlinkAssets) =>
  useProtocolContract<TAggregatorV3Interface>('ChainlinkOracles', asset);

export const useContractVestaInterestManager = () =>
  useProtocolContract<TVestaInterestManager>(EContractName.VestaInterestManager);

export const useContractVestaEIR = (asset: EVestaAsset) =>
  useProtocolContract<TVestaEIR, EVestaAsset>('VestaEIR', asset);

export const useContractSavingModule = () =>
  useProtocolContract<TVestaSavingModule>(EContractName.VestaSavingModule);

export const useContractSavingModuleSP = () =>
  useProtocolContract<TSavingModuleStabilityPool>(EContractName.SavingModuleStabilityPool);

export const useContractGMXStakingBonus = () =>
  useProtocolContract<TVestaGMXBonusStaking>(EContractName.VestaGMXBonusStaking);

export const useContractVestaDexTrader = () =>
  useProtocolContract<TVestaDexTrader>(EContractName.VestaDexTrader);
